
<template>
<div id="artist_page" v-if="loaded" :class="{no_top_margin: !is_mobile()}">

    <div id="hero">
            <div id="artist_pics">
               <div v-for="(pic,index) in artist.artist_pics" :key="pic.id" :class="'pic'+index" :style="'background-image: url('+pic.url+')'"></div>
            </div>
        <div class="centered">
            
            <h1 class="title">{{artist.name}}</h1>
            <div id="top_head">
                <h2 class="title colord">{{artist.genres_string}}</h2>
                <div class="share_line">
                    <a v-for="soci in artist.soci_list" :key="soci.type" :title="soci.name" target="_blank" :href="soci.value"><i :class="soci.icon"></i></a>
                    <a  title="שיתוף" @click="$bus.$emit('share_url', 'Artist/' + artist.id)"><i class="fas fa-share"></i></a>
                </div>
            </div>
            
        <div class="contact_details">
          <ul v-if="artist.con2_name != ''">
            <li><label>סוכן</label><span v-text="artist.con2_name"></span></li>
            <li v-if="!isNull(artist.con2_email)"><label>מייל</label><span v-text="artist.con2_email"></span></li>
            <li v-if="!isNull(artist.con2_phone1)"><label>טלפון</label><span v-text="artist.con2_phone1"></span></li>
          </ul>
          
          <ul v-if="artist.con1_name != ''">
            <li><label>יחצן</label><span v-text="artist.con1_name"></span></li>
            <li v-if="!isNull(artist.con1_email)"><label>מייל</label><span v-text="artist.con1_email"></span></li>
            <li v-if="!isNull(artist.con1_phone1)"><label>טלפון</label><span v-text="artist.con1_phone1"></span></li>
          </ul>
          
          <ul v-if="artist.con3_name != ''">
            <li><label>בוקינג</label><span v-text="artist.con3_name"></span></li>
            <li v-if="!isNull(artist.con3_email)"><label>מייל</label><span v-text="artist.con3_email"></span></li>
            <li v-if="!isNull(artist.con3_phone1)"><label>טלפון</label><span v-text="artist.con3_phone1"></span></li>
          </ul>
        </div>

			<div class="clr"></div>   
             <div class="about" v-html="artist.bio"></div>
            
                

			<div class="artist_pic" style="background-image: url({crm_storage_tumb id=$data.pic width=200 height=200})"></div>
        </div>
    </div>
    
	<div class="centered">
	<section id="linktons_slide" v-if="hero_items.length > 0" style="margin-bottom:40px;">
        <div class="title">אלבומים </div>
        <carousel :items-to-show="3" dir="rtl">
        <slide v-for="item in hero_items"  :key="item.id">
            <div class="item" >
                <div class="pic" :style="'background-image:url('+item.pic_tumb_share+')'"></div>
                <div class="item_title">{{item.artist.name}}</div>
                <!-- <div class="date">{{item.online_date_format}}</div> -->
                <div class="item_subtitle"> {{item.name}}</div>
            </div>
        </slide>
        </carousel>
	</section>
	<section id="linktons_list" v-if="items.length > 0"> 
    
        <div class="title mid">סינגלים</div>

        <div id="items_list">
                        
            <div class="item_wrapper"  v-for="item in items" :key="item.id">
                <drag :key="item.id" class="drag" :data="item">
                <CatalogItem :item="item" @play="$emit('play', item)" @open_widget="$emit('open_widget', item)" />
                </drag>
            </div>
            
        </div>
        <div class="clr"></div>
        <Loader v-if="on_loading" />
	
	</section>	
		<!-- {if $shows }
		<div class="centered">
        <h3 class="title">הופעות חיות</h3>
        <h3 class="title colord">בזמן הקרוב</h3>
    
		<div class="shows_list">
            
        {foreach $shows as $item} 
            <div class="item">

				<div class="fl">

					<span class="show-date"><i class="material-icons dp48">date_range</i>{$item.date}</span>
					<span class="show-time"><i class="material-icons dp48">access_time</i>{$item.time}</span>
					<span class="show-place"><i class="material-icons dp48">location_on</i>{$item.location}</span>
					{if $item.buy_link != ""}<a class="btn" href="{$item.buy_link}" target="_blank"><i class="material-icons dp48">bookmark_border</i>{LANGS::get_word('buy_tickets')}</a>{/if}
				</div>
				<div class="">
					<div class="artist-title">{$item.artist_name}</div>
					<div class="show-title">{$item.text|strip_tags}</div>
				</div>
			</div>

			{/foreach}

		</div>
		</div>
	{/if} -->
    </div>
</div>
</template>

<script>

import Loader from '../components/loader.vue';
import { Drag } from "vue-easy-dnd";

import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide/*, Pagination, Navigation*/ } from 'vue3-carousel'

import CatalogItem from '../components/catalog/item.vue';
export default {
  components: { 
    Carousel,
    Slide,/*
    Pagination,
    Navigation,*/ 
    CatalogItem, Drag, Loader },
  data(){
        return {
            id: this.$route.params.id,
            items: [],
            hero_items: [],
            gallery: [],
            artist: [],
            loaded:false,

            on_loading: false,
            page: 0,
            searchTimer: null,
            xhr: false,

        }
    }, 
    mounted: function(){
        this.load_profile();
        this.load_results();
        
        window.onscroll = () => {
        if  (!this.on_loading && document.documentElement.scrollTop + 400 >= (document.body.scrollHeight - window.innerHeight ))
        {
            this.load_results();
        }
        };
    },
    methods: 
    {
        load_profile: function(){
        
            this.api({ action: 'artists/get_profile',  data: { id: this.id } }, (data) => { 
                this.artist = data.data; 
                this.gallery = data.data.pics_artist; 
                //this.items = data.data.items; 
                this.hero_items = data.data.hero; 

                this.loaded = true;
            });

        },

        load_results(){
        
            this.page++;

            if (this.page == 1) this.items = [];

            this.on_loading = true;
            if (this.xhr) this.xhr.cancel();
            this.xhr = this.api({ action: 'vod/results', data: { page: this.page, lecturer: this.id, is_album: false} }, (data) => { 
                
                this.parse_items(data.data.items);
                
                if (this.page == 1) this.items = data.data.items; 
                else this.items.push(...data.data.items); 
                this.on_loading = false;
            });

        }



    }
}

</script>
<style scoped lang="scss">
#artist_page { 
    
    h1 { font-size: 60px !important; line-height: normal !important; margin: 0px !important; 
        @media only screen and (max-width: 600px) { font-size: 40px !important; text-align: right !important; }
    }
    h2 { font-size: 35px !important; font-weight: normal !important; line-height: normal !important;
        @media only screen and (max-width: 600px) { font-size: 20px !important; }
    }

    #top_head { display: flex; flex-direction: row; justify-content: space-between; align-items: center; width:60%; border-bottom:1px solid #979797; margin-bottom: 25px;
        .share_line { 
            a { margin-right: 10px; color: rgb(117, 117, 117);}
        }
    }

    .about{
        line-height: 1.3;
        p{    font-size: 23px;color: #333;}
    }
    .title {color: #000; font-size: 70px;margin-bottom: 20px; font-weight: 900; font-family: 'almoni-dl';
        @media only screen and (max-width: 600px) { font-size: 30px; text-align: center; }
    }
	#linktons_slide{ 
        &{ 
            @media only screen and (min-width: 600px) { margin-top: 50px;}
        }

        .item{ width: calc(100% - 15px);
            .pic{width: 100%; border-radius: 33px; background-size: cover; background-position: center; padding-bottom: 60%; margin-bottom: 10px;}
        .item_title { font-weight: bold;}
        }
    }
    #linktons_list{
        .item:nth-child(4n+1){clear: both;}
        .item{margin-bottom: 30px;}
	.pic{width: 100%; border-radius: 33px; background-size: cover; background-position: center; padding-bottom: 60%;}

    }
	.breadcrumb {
		&{color: #797979;font-size: 15px;}
		.fa-chevron-left{float: unset  ;  font-size: 11px;  margin: 0 3px;}
			li {display: inline-block!important}
	
	}
	.soci{ width: 38vw;height: 50px;border-bottom: 2px solid #ccc;margin-bottom: 30px}
	.soci a{border: none;float:left}
    #hero {
        & { background-image: linear-gradient(to left, #f6f8f7, #f1f2f7 0%); position: relative; padding-bottom: 40px; padding-top: 50px; min-height: 400px; 
            @media only screen and (min-width: 600px) { margin-bottom: 100px; }
            @media only screen and (max-width: 600px) { padding:20px; }
        }
        #artist_pics{ position: absolute; left: 0px; 
            .pic0,.pic1,.pic2 { width:200px;  border-radius: 30px; background-size: cover; background-position: center center; position: absolute; box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.09);
                &::after { content: ""; display: block; padding-bottom: 100%; }
            }
            
            .pic0 { left: -60px; width: 307px; top: -10px;
                @media only screen and (max-width: 600px) { width: 70px; left:10px; top:-15px; border-radius: 10px; }
            }
            .pic1 { left: 270px; width: 233px; top: 42px; 
                @media only screen and (max-width: 600px) { width: 70px; left: 30px; top: 42px; border-radius: 10px; }
            }
            .pic2 { left: 100px; width: 275px; top: 200px; 
                @media only screen and (max-width: 600px) { width: 70px; left: 10px; top: 122px; border-radius: 10px; display: none; }
            }
        }
        
    }
    .about { font-size: 22px; ; width:60%; 
        @media only screen and (max-width: 600px) { width: 100%; font-size: 20px; } 
    }

        
    .contact_details { padding-top: 15px; display: flex; gap:15px;
    ul { display: block; margin-bottom: 15px;
        li { 
        label { font-weight: bold; margin-left: 10px;}
        }
    }

    }
}
</style>